import InvestmentDetailsCard from './InvestmentDetailsCard';

export default InvestmentDetailsCard;